import React from "react";
import styles from "./page-title.module.css";
import { MyIcons } from "../../icons/my-icons";

const PageTitle = ({ iconName, title, style }) => {
  return (
    <div className={styles.pageTitleContainer} style={style}>
      <MyIcons height={32} width={32} name={iconName} color={"var(--black)"}/>
      <h1 className={styles.title}>{title}</h1>
    </div>
  );
};

export default PageTitle;